/*
 * @Author: yuchen
 * @Date: 2023-06-19 20:24:28
 * @Description:
 * @LastEditTime: 2023-07-26 21:07:23
 * @LastEditors: yuchen
 */
const BASE_URL = '/api/v1';
const HUB_BASE_URL_SLUG = 'hub';
const HUB_BASE_URL = '/hub/api/v1';
const OFFICIAL_BASE_URL_SLUG = 'official';
const OFFICIAL_BASE_URL = '/official/api/v1';
const RBAC_BASE_URL_SLUG = 'rbac';
const RBAC_BASE_URL = '/rbac';
const SCENE_EDITOR_BASE_URL_SLUG = 'scene_editor';
const SCENE_EDITOR_BASE_URL = '/scene_editor/api/v1';
const LOGIN_BASE_URL_SLUG = 'login';
const LOGIN_BASE_URL = '/login/api/v1';
const WX_USER_ACCOUNT_URL = `${LOGIN_BASE_URL}/login/wechat`;
// 3.1.0 之前用到的微信浏览器内部授权登录的链接请求
const OLD_WX_USER_ACCOUNT_URL = `/api/v1/wx_login`;
const OPEN_API_BASE_URL_SLUG = 'openapi';
const OPEN_API_BASE_URL = '/openapi/api/v1';

export { BASE_URL, HUB_BASE_URL, HUB_BASE_URL_SLUG, LOGIN_BASE_URL, LOGIN_BASE_URL_SLUG, OFFICIAL_BASE_URL, OFFICIAL_BASE_URL_SLUG, OLD_WX_USER_ACCOUNT_URL, OPEN_API_BASE_URL, OPEN_API_BASE_URL_SLUG, RBAC_BASE_URL, RBAC_BASE_URL_SLUG, SCENE_EDITOR_BASE_URL, SCENE_EDITOR_BASE_URL_SLUG, WX_USER_ACCOUNT_URL };
